<template>
<div class="box-labourParticulars">
    <div class="nav">
        <router-link to="Appendix"><img src="../../assets/up.png" alt="" class="upClass"></router-link>
        差旅费用标准管理规定
        <img src="../../assets/search.png" alt="" class="searchClass" @click="getOnPage">
    </div>
    <div class="swiper-container">
        <div class="swiper-wrapper">
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active" id="title_name_nac">交通费</h4>
                    <span class="labourParticulars-title-content-active" id="TitileId">1. 中层管理者、教师及员工飞机乘坐经济舱，火车乘坐硬卧或二等座，轮船乘坐三等舱。</span>
                    <span class="labourParticulars-title-content-active" id="TitileId">2. 出差期间每人每天交通费最高标准为 50 元，超过部分自理；也可申报交通补贴 50元，申报同时不再报销出差地市内交通费用。车站、机场往返出发地及目的地的费用实报实销。</span>
                    <span class="labourParticulars-title-content-active" id="TitileId">3. 参加公司组织的会议及培训期间，不享受交通补贴。出差人员自备车辆的，按照实际里程报销汽油费及过路过桥费，不享受交通补贴。</span>
                    <img src="../../assets/xiaNoPage.png" alt="" class="labourParticulars_bottomImg">
                </div>
            </div>
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active" id="title_name_nac">住宿费</h4>
                    <span class="labourParticulars-title-content-active" id="TitileId">1. 中层管理者（标准：500元以内）、教师及员工（标准：350元以内）出差应两人住一间双人标准间，按照一个人的住宿标准执行，级别不同的，以高级别的住宿标准为准，超过标准部分自理；如遇当地展会等特殊情况超过住宿标准，需事先得到直接主管的批准。</span>
                    <span class="labourParticulars-title-content-active" id="TitileId">2. 酒店就餐的餐费应在餐费类报销，电话费（非因公）、上网费、洗衣费、娱乐费以及各种因私开销除经机构负责人特别批准，由员工自付；因公务发生的长途电话费用应附上电话单明细以供审核。</span>
                    <img src="../../assets/xiaNoPage.png" alt="" class="labourParticulars_bottomImg">
                </div>
            </div>
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active" id="title_name_nac">伙食补助</h4>
                    <span class="labourParticulars-title-content-active" id="TitileId">1. 出差期间每人每天伙食费最高标准为 70 元，超过部分自理；也可申报伙食补贴 70元/天，申报同时不再报销餐费。在出差期间参与招待宴请的，每参加一次调减 30元伙食补贴。</span>
                    <span class="labourParticulars-title-content-active" id="TitileId">2. 参加公司组织的会议及培训期间，不享受伙食补贴。</span>
                    <span class="labourParticulars-title-content-active" id="TitileId">3. 采用乘坐飞机以外的其他交通方式的，往返累计用时在 12 小时以内的可享受 35 元在途伙食补贴；往返累计用时在 12 小时（含）以上的可享受 70 元在途伙食补贴，并根据实际出发和到达时间酌情判断补助标准。</span>
                    <img src="../../assets/xiaNoPage.png" alt="" class="labourParticulars_bottomImg">
                </div>
            </div>
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active" id="title_name_nac">其他</h4>
                    <span class="labourParticulars-title-content-active" id="TitileId">1. 出差人员可报销与工作有关的物资托运费用。</span>
                    <span class="labourParticulars-title-content-active" id="TitileId">2. 出差行程应尽量选择最短路线，除特殊情况（如铁路发生故障等）不得绕道；换乘中转不得无故停留，否则费用自理，因游览或走访亲友、就近绕道回家探亲或休假而发生的费用由个人自理。</span>
                    <span class="labourParticulars-title-content-active" id="TitileId">3. 休假去外地，受机构委托处理公务的，因公务发生的邮电费和市内交通费据实报销，但往返差旅费自理。</span>
                    <span class="labourParticulars-title-content-active" id="TitileId">4. 出差期间因病休假的，按标准发给伙食补贴费，不享受交通补贴费。</span>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
export default {
    data() {
        return {
            fingerprintShow: false,
            flowShow: false,
            agreementShow: false
        };
    },
    methods: {
        fn() {

        },
        getOnPage() {
            this.$router.push({
                name: 'Search',
                params: {
                    code: "6"
                }
            })
        },
    },
    mounted() {
        this.fn();
        var mySwiper = new Swiper(".swiper-container", {
            direction: "vertical" // 垂直切换选项
            // loop: true // 循环模式选项
        });
    }
};
</script>

<style>
.swiper-container {
    width: 100%;
    height: 100%;
}

.box-labourParticulars {
    width: 100%;
    height: 100%;
    background: rgba(244, 244, 244, 1);
    overflow: hidden;
}

.nav {
    width: 100%;
    height: 50px;
    background: #11a093;
    text-align: center;
    line-height: 50px;
    color: #ffffff;
    position: relative;
    margin-bottom: 17px;
}

.upClass,
.searchClass {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
}

.upClass {
    width: 12px;
    float: left;
    left: 10px;
}

.searchClass {
    width: 19px;
    float: right;
    right: 10px;
}

.labourParticulars {
    width: 90%;
    height: 83%;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 12px 0px rgba(136, 135, 135, 0.5);
    border-radius: 11px;
    padding-top: 5%;
    position: relative;
}

.labourParticulars .labourParticulars-title {
    text-align: center;
    font-weight: 600;
}

.labourParticulars .labourParticulars-hw {
    margin-bottom: 20px;
}

.labourParticulars p {
    color: #696969;
    font-size: 16px;
    margin: 20px 16px 0;
}

.labourParticulars span {
    display: block;
    line-height: 30px;
    margin-left: 16px;
    margin-right: 16px;
    color: #888787;
    font-size: 14px;
}

.labourParticulars .spanClass {
    text-indent: 30px;
    line-height: 23px
}

.labourParticulars_bottomImg {
    width: 15%;
    display: block;
    left: 0;
    right: 0;
    margin: auto;
    position: absolute;
    bottom: 12px;
}

.QRcode {
    width: 30%;
    display: block;
    margin: 10px auto;
}
.labourParticulars-title-active {
    font-size: 16px
}
.labourParticulars-title-content-active {
    letter-spacing:2px;
    line-height: 30px;
}
#title_name_nac {
    margin-bottom: 20px;
}
#TitileId {
    text-indent: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Appendix/appendix6.vue